export default __webpack_public_path__ + "static/media/success.ebe68d7f.svg";